/* eslint-disable radix */
import { titleCase } from 'title-case';
import { Prescription } from 'types/Prescription';

export enum INTERVALS {
  'day' = 'day',
  'week' = 'week',
  'month' = 'month',
  'everyTwoMonths' = 'everyTwoMonths',
  'everyThreeMonths' = 'everyThreeMonths',
  'everySixMonths' = 'everySixMonths',
  'year' = 'year',
}

export const INTERVAL_LABELS = {
  [INTERVALS.day]: { label: 'Day' },
  [INTERVALS.week]: { label: 'Week' },
  [INTERVALS.month]: { label: 'Month' },
  [INTERVALS.everyTwoMonths]: { label: '2 Months' },
  [INTERVALS.everyThreeMonths]: { label: '3 Months' },
  [INTERVALS.everySixMonths]: { label: '6 Months' },
  [INTERVALS.year]: { label: 'Year' },
};

export const formatPrescription = ({
  prescription,
  showName = false,
}: {
  prescription: Prescription;
  showName?: boolean;
}) => {
  const name = `${titleCase(prescription.label_name.toLowerCase())}`;
  const nameString = showName ? `${name} - ` : '';

  if (!prescription.times || !prescription.interval) {
    if (parseInt(prescription.drug_quantity_per_period) >= parseInt(prescription.days_per_supply_period)) {
      const times = +prescription.drug_quantity_per_period / +prescription.days_per_supply_period;
      return `${nameString}${times} ${times > 1 ? 'times' : 'time'} per day`;
    }

    // otherwise default to x per n days
    const times = parseInt(prescription.drug_quantity_per_period);
    return `${nameString}${times} ${times > 1 ? 'times' : 'time'} per ${prescription.days_per_supply_period} days`;
  }

  const { times, pack_type, package_quantity } = prescription;
  const frequency = `${times === 1 ? `${times} time` : `${times} times`}`;
  const interval = INTERVAL_LABELS[prescription.interval].label.toLowerCase();
  const type = pack_type ? `(${titleCase(pack_type.toLowerCase())})` : '';
  const quantity = package_quantity ? `(Pkg Qty: ${package_quantity})` : '';
  return `${nameString}${frequency} per ${interval} ${type} ${quantity}`;
};
